import { render } from "./TranslationModal.vue?vue&type=template&id=5e12c118&scoped=true"
import script from "./TranslationModal.vue?vue&type=script&lang=js"
export * from "./TranslationModal.vue?vue&type=script&lang=js"

import "./TranslationModal.vue?vue&type=style&index=0&id=5e12c118&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e12c118"]])

export default __exports__